module.exports = __webpack_public_path__ + "static/media/Cookie Policy.5decb94c.pdf";